module.exports = __webpack_public_path__ + "img/logo-sv.c3ca35fe.svg";